import { Component, OnInit } from '@angular/core';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';

@Component({
  selector: 'app-sgzp-master-forgot-password',
  templateUrl: './sgzp-master-forgot-password.component.html',
  styleUrls: [
    '../style/global.css',
    './sgzp-master-forgot-password.component.css',
  ],
})
export class SgzpMasterForgotPasswordComponent
  extends BaseLoginComponent
  implements OnInit {
  async init(): Promise<void> { }
}
